module.exports = __webpack_public_path__ + "img/43.eab8fa60.jpg";